import { useQuery } from "@tanstack/react-query";
import i18next from "i18next";
import { Alert, Col, Container, Row } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import { StellantisQuoteRequestDTO } from "src/api/models/StellantisDTO";
import CardPlaceholder from "src/components/CardPlaceholder/CardPlaceholder";
import { StellantisOpportunityFunnel } from "src/components/Stellantis";
import { useApiClient } from "src/hooks/useApiClient";
import { toast } from 'react-toastify';

function StellantisOpportunityWizardPage() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { apiClient } = useApiClient();

  const { isLoading, data, isError, error } = useQuery<StellantisQuoteRequestDTO>({
    queryKey: ['stellantis_quote', [id]],
    queryFn: async () => {
      return apiClient.stellantisControllerService.findQuote(id!);
    },
    enabled: !!id,
    refetchOnWindowFocus: false,
    retry: false,
  });

  const showFunnel = Boolean(!isLoading && !isError && data?.id);
  const showError = Boolean(isError && error?.message);

  const handleSuccess = (apiResponse: any) => {
    toast.success(i18next.t('opportunity_created_successfully'))
    navigate('/my-opportunities')
  }

  return (
    <div>
      <Container fluid>
        <Row>
          <Col md={6} className="display-6">
            {i18next.t('create_opportunity')}
          </Col>
        </Row>
        <div className="mt-4">
          {isLoading && <CardPlaceholder />}
          {showFunnel && <StellantisOpportunityFunnel
            quoteRequest={data!}
            onSuccess={handleSuccess}
            onClose={() => navigate('/stellantis-quotes')}
          />}
        </div>
        {showError && (
          <Alert variant="danger" className="my-4">
            <div>{String(error?.message)}</div>
          </Alert>
        )}
      </Container>
    </div>
  )
}

export default StellantisOpportunityWizardPage;
